'use strict';

/**
 * Инит валидации форм
 * @module
 */

// ----------------------------------------
// Imports
// ----------------------------------------

import 'custom-jquery-methods/dist/has-inited-key';
import 'custom-jquery-methods/dist/node-name';
import 'jquery-validation';
import './validation-extend';
import './change-text';
// import phoneMask from './phone-mask';
import Preloader from './preloader';

// ----------------------------------------
// Private
// ----------------------------------------

function formJsChangeFile ($element, $form) {
	$form.data('validator').element($element);

	let $block = $element.closest('.custom-file');
	let $inputResult = $block.find('.custom-file__result');

	let fileList = $element[0].files;
	let names = [];
	let sizes = 0;

	if (fileList.length) {
		$block.addClass('has-file');
	} else {
		$block.removeClass('has-file');
	}

	for (let i = 0; i < fileList.length; i++) {
		let file = fileList[i];
		names.push(file.name);
		sizes += file.size;
	}

	sizes = (sizes / 1024).toFixed(2);

	if (names.length > 1) {
		names = names.length;
	} else {
		names = names[0];
		if (!names) {
			$inputResult.changeMyText('default');
			return;
		}
		names = '<span class="_ellipsis" title="' + names + '">' + names + '</span>';
	}

	$inputResult.changeMyText('changed', [names, sizes]);
}

function customFile ($form) {
	let $el = $form.find('.js-custom-file');

	$el.on('change', function () {
		formJsChangeFile($(this), $form);
	});

	$form.on('click', '.js-custom-file-clear', function (event) {
		event.stopPropagation();
		$el.val('');
		formJsChangeFile($el, $form);
	});
}

/**
 * old function to show popup
 */

function noty (message, type, time, code, param, gaCode) {
	$.magnificPopup.close();
	setTimeout(function () {
		$.magnificPopup.open({
			items: {
				src: `<div class="noty magnific-popup magnific-popup--noty">
							<div class="noty__image">
								<img src="/Media/assets/css/static/pic/noty--${type}.jpg" alt="">
								<div class="noty__icon">
									<svg>
										<use xlink:href="/Media/assets/images/sprites/icons.svg#${type}"></use>
									</svg>
								</div>
							</div>
							<div class="noty__message">${message}</div>
							<button class="button button--yellow js-mfp-close">
								<span class="button__text">OK</span>
							</button>
						</div>`,
				type: 'inline'
			},
			removalDelay: 200,
			mainClass: 'zoom-in',
			autoFocusLast: false,
			fixedContentPos: false,
			callbacks: {
				open: function () {
					/* eslint-disable no-eval */
					if (code && param && (window['yaCounter' + code] !== undefined)) {
						eval('yaCounter' + code + '.reachGoal("' + param + '");');
					}

					if (gaCode) {
						eval('ga("send", "event", "button", "' + gaCode + '")');
					}
					/* eslint-eneable no-eval */
				}
			}
		});
	}, 250);
};

/**
 * Параметры по умолчанию
 * @const {Object}
 * @private
 */
const configDefault = {
	ignore: ':hidden, .js-ignore',
	errorClass: 'has-error',
	validClass: 'is-valid',
	get classes () {
		return {
			error: this.errorClass,
			valid: this.validClass,
			labelError: 'label-error',
			formError: 'form--error',
			formValid: 'form--valid',
			formPending: 'form--pending'
		};
	},

	onfocusout (element) {
		this.element(element);
	},

	highlight (element) {
		element.classList.remove(this.settings.classes.valid);
		element.classList.add(this.settings.classes.error);
	},

	unhighlight (element) {
		element.classList.remove(this.settings.classes.error);
		element.classList.add(this.settings.classes.valid);
	},

	submitHandler (form) {
		let $form = $(form);
		let actionUrl = $form.data('ajax');
		if (typeof (actionUrl) !== 'string') {
			window.alert([
				'Error!',
				'--------------------',
				'ajax обработчик не указан'
			].join('\n'));
			return;
		}

		let preloader = new Preloader($form.find('[type="submit"]'));
		preloader.show();

		let formData = new window.FormData();
		formData.append('xhr-lang', $('html').attr('lang') || 'ru');

		// игнорируемые типы инпутов
		let ignoredInputsType = [
			'submit',
			'reset',
			'button',
			'image'
		];

		let token;

		$form.find('input, textarea, select').each((i, element) => {
			let {value, type} = element;
			if (~ignoredInputsType.indexOf(type)) {
				return true;
			}

			let $element = $(element);
			let elementNode = $element.nodeName();
			let elementName = $element.data('name') || $element.attr('name') || null;

			if (elementName === null) {
				return true;
			}

			if (elementName === 'token') {
				token = $element.val();
			}

			switch (elementNode) {
				case 'input':
					if (type === 'file' && element.files && element.files.length) {
						for (let i = 0; i < element.files.length; i++) {
							let file = element.files[i];
							formData.append(elementName, file);
						}
					} else {
						if ((type === 'checkbox' || type === 'radio') && !element.checked) {
							break;
						}
						formData.append(elementName, value);
					}
					break;

				case 'textarea':
					formData.append(elementName, value);
					break;

				case 'select':
					let multiName = /\[\]$/;
					if ((multiName.test(elementName) || element.multiple) && element.selectedOptions && element.selectedOptions.length) {
						elementName = elementName.replace(multiName, '');
						for (let i = 0; i < element.selectedOptions.length; i++) {
							let option = element.selectedOptions[i];
							if (option.disabled) {
								continue;
							}
							formData.append(elementName, option.value);
						}
					} else {
						formData.append(elementName, value);
					}
					break;
			}
		});

		let xhrUrl = actionUrl;
		let xhr = new window.XMLHttpRequest();

		xhr.open('POST', xhrUrl);
		xhr.onreadystatechange = function () {
			if (xhr.readyState === 4) {
				getResponse($form, xhr, token);
			}
		};
		xhr.send(formData);
		return false;
	}
};

/**
 * Обработка ответа от сервера
 * @param {jQuery} $form
 * @param {Object} xhr
 * @param {number} xhr.status
 * @param {string} xhr.statusText
 * @param {Object|string} xhr.response
 * @param {string} [xhr.response.redirect] - урл для редиректа, если равен текущему урлу - перегражаем страницу
 * @param {boolean} [xhr.response.reload] - перегрузить страницу
 * @param {boolean} [xhr.response.reset] - сбросить форму
 * @param {Array} [xhr.response.clear] - сбросить форму
 * @private
 */
function getResponse ($form, xhr, token) {
	let {status, statusText, response} = xhr;
	let {preloader, ajax, analytics} = $form.data();
	let actionUrlSlow = ajax + 'Slow';

	// все плохо
	if (status !== 200) {
		console.log(xhr);
		window.alert([
			'Error!',
			'status: ' + status,
			'--------------------',
			statusText
		].join('\n'));
		return false;
	}

	// обрабатываем ответ
	// ------------------

	if (typeof response === 'string') {
		response = JSON.parse(response);
	}

	if (response.success) {
		if (analytics) {
			let type = analytics.type;
			let code, nameService;

			if (type === 'orderService') {
				if (analytics.service) {
					nameService = analytics.service;
				} else {
					nameService = $form.find('[data-name="service"]').val();
				}

				code = 'gtag("event","' + type + '-' + nameService + '",{"event_category":"' + type + '","event_label":"' + window.location.pathname + '"});';
				if (window.fbq !== undefined) {
					window.fbq('track', 'CompleteRegistration');
					console.info('Выполнена строка = fbq("track","CompleteRegistration")');
				} else {
					console.error('Объект fbq не определен! Строка НЕ выполнена = fbq("track","CompleteRegistration")');
				}
			} else {
				code = 'gtag("event","' + type + '-' + window.location.pathname + '",{"event_category":"' + type + '","event_label":"' + window.location.pathname + '"});';
			}

			if (window.ga !== undefined) {
				/* eslint-disable no-eval */
				eval(code);
				/* eslint-eneable no-eval */
				console.info('Выполнена строка = ' + code);
			} else {
				console.error('Объект ga не определен! Строка НЕ выполнена = ' + code);
			}
		}

		if (response.mfpClose) {
			$.magnificPopup.close();
		}

		if (response.lastID) {
			let requestSlow = new window.XMLHttpRequest();
			requestSlow.open('POST', actionUrlSlow);
			let formDataSlow = new window.FormData();
			formDataSlow.append('lastID', response.lastID);
			formDataSlow.append('token', token);
			requestSlow.send(formDataSlow);
		}

		if (response.clear) {
			if (Array.isArray(response.clear)) {
				response.clear.forEach(clearSelector => {
					$form.find(clearSelector).val('');
				});
			} else {
				// игнорируемые типы инпутов
				let ignoredInputsType = [
					'submit',
					'reset',
					'button',
					'image'
				];
				$form.find('input, textarea, select').each((i, element) => {
					if (
						~ignoredInputsType.indexOf(element.type)
					) {
						return true;
					}
					element.value = '';
				})
				;
			}
		} else if (response.reset) {
			$form.trigger('reset');
		}

		if (!response.nopopap && response.response) {
			noty(response.response, 'success', 3500);
		}

		preloader.hide();
	} else {
		if ($form.find('.form-error').length) {
			$form.find('.form-error').text(response.response);
		} else {
			$(`<div class="form-error">${response.response}</div>`).prependTo($form);
		}
		preloader.hide();
	}

	if (response.reload || window.location.href === response.redirect) {
		return window.location.reload();
	}

	if (response.redirect) {
		return (window.location.href = response.redirect);
	}
}

/**
 * Пользовательские обработчики формы
 * @param {jQuery} $form
 * @param {Object} Validator {@link https://jqueryvalidation.org/?s=validator}
 * @param {Function} Validator.resetForm {@link https://jqueryvalidation.org/Validator.resetForm/}
 */
function setHandlers ($form, Validator) {
	// сброс формы
	$form.on('reset', () => Validator.resetForm());

	// дальше ваш код
}
// ----------------------------------------
// Public
// ----------------------------------------

/**
 * @param {string} [selector=".js-form"]- поиск элементов по селектору
 * @param {jQuery} [$context=null] - контекст в котором будет выполнен поиск селектора
 * @sourceCode
 */
function validation (selector, $context = null) {
	let $forms = (selector && selector.jquery) ? selector : $(selector, $context);
	$forms.each((i, el) => {
		let $form = $(el);
		if ($form.hasInitedKey('validator', false)) {
			return true;
		}

		let configUser = $form.data('validation-config') || {};
		let configCurrent = $.extend(true, configDefault, configUser);

		// phoneMask('[data-phone-mask]', $form);
		$form.validate(configCurrent);
		setHandlers($form, $form.data('validator'));

		if ($form.find('.custom-file').length) {
			customFile($form);
		}
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

export default validation;



// WEBPACK FOOTER //
// ./src/js/_modules/validation.js